import React from "react";
import { Routes, Route } from "react-router-dom";
import LabRegister from "../screens/LabRegister/LabRegister";
import LabTurn from "../screens/LabRegister/LabTurn/LabTurn";
import NotFound from "../screens/NotFound";

const LabRegisterRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LabRegister />} />
      <Route path="/Madrugada" element={<LabTurn turn={"Madrugada"} />} />
      <Route path="/Mañana" element={<LabTurn turn={"Mañana"} />} />
      <Route path="/Tarde" element={<LabTurn turn={"Tarde"} />} />
      <Route path="/Noche" element={<LabTurn turn={"Noche"} />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default LabRegisterRoutes;
